import { render, staticRenderFns } from "./Housing.vue?vue&type=template&id=f3c4f9e8&scoped=true&"
import script from "./Housing.vue?vue&type=script&lang=js&"
export * from "./Housing.vue?vue&type=script&lang=js&"
import style0 from "./Housing.vue?vue&type=style&index=0&id=f3c4f9e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c4f9e8",
  null
  
)

export default component.exports